import React, { Component } from 'react';
import i18n from 'i18n-react';
import logo from 'assets/images/logo/logo.png';
import { baseAppId, points, storageKeys } from 'settings';
import { APIHandler, StorageHandler, ContentHeader, DashboardSlider, DashboardChart, RewardMenu } from 'C4';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

export default class DashboardView extends Component {
  constructor() {
    super();

    this.state = {
      rewardsData: [],
      dashboardData: [],
      sharesData: [],
      trainData: [],
      earnedXP: null,
      loading: false,
      completedItems: {},
      uncompletedItems: {},
    };
  }

  async componentDidMount() {
    this.getDashboardData();
    this.getUserData();
    this.sortItems();
  }

  getDashboardData() {
    this.setState({ loading: true });
    DataHandler.matchAppId().then((appId) => {
      StorageHandler.load(storageKeys.user).then((userObj) => {
        if (userObj) {
          const { email } = userObj;
          APIHandler.getDashboardItems(
            appId,
            email,
            points.maxSharePoints,
            points.rewardsPoints,
            points.sharePoints,
            points.trainingPoints,
          ).then((res) => {
            console.log(res);
            this.setState({
              dashboardData: res,
              rewardsData: res.rewards,
              sharesData: res.shares,
              trainData: res.train_items,
              loading: false,
            });
            this.sortItems();
          });
        }
      });
    });
  }

  getUserData() {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      if (userObj) {
        const { email } = userObj;
        APIHandler.getLeaderBoard(baseAppId, email).then((res) => {
          this.setState({ earnedXP: res.user.xp });
        });
      }
    });
  }

  sortItems() {
    const { trainData } = this.state;
    this.setState({
      completedItems: {
        train: trainData.completed_items,
      },

      uncompletedItems: {
        train: trainData.uncompleted_items,
      },
    });
  }

  render() {
    const { dashboardData, sharesData, trainData, rewardsData, earnedXP, loading, completedItems, uncompletedItems } =
      this.state;

    const { maxTotalPoints } = points;

    let totalPercentage = Math.ceil((100 / maxTotalPoints) * earnedXP);

    if (totalPercentage > 100) {
      totalPercentage = 100;
    }

    return (
      <div className="contentContainer BookingForm">
        <RewardMenu />

        <div className="header">
          <h3>{i18n.translate('rewards.dashboardView.title')}</h3>
        </div>
        <hr />
        <div className={`dashboardView ${loading ? 'overflow-hidden' : ''}`}>
          <div className="dashboardHolder">
            <ContentHeader
              header={i18n.translate('contentHeaders.dashboard')}
              subtitle={i18n.translate('pageDescriptions.dashboard')}
              icon="chart-pie"
            />

            <div className="progress">
              {!loading && (
                <React.Fragment>
                  <div className="progress-data">
                    <div className="title">
                      <h1>Overview</h1>
                      <hr className="shortLine" />
                    </div>
                    <div className="progress-charts">
                      <div className="total">
                        <p className="chart-header">Total progress:</p>
                        <div className="totalxp">
                          <h1>
                            {earnedXP ? `${earnedXP}` : 0}
                            <span className="text-smaller">{' pts'}</span>
                          </h1>
                        </div>
                        <div className="total-progress">
                          <div
                            className="progress-bar"
                            style={{
                              height: `${totalPercentage}%`,
                              borderRadius: totalPercentage === 100 ? '1rem' : '0 0 1rem 1rem',
                            }}
                          />
                          <p>{totalPercentage ? `${totalPercentage}%` : ''}</p>
                        </div>
                      </div>
                      {trainData && sharesData && rewardsData && (
                        <React.Fragment>
                          <DashboardChart className="shares" title="Shares" amount={sharesData.percentage_completed} />
                          <DashboardChart
                            className="rewards"
                            title="Bookings"
                            amount={rewardsData.percentage_completed}
                          />
                          <DashboardChart
                            className="train"
                            title="Train Sessions"
                            amount={trainData.percentage_completed}
                          />
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                  {completedItems.train ? (
                    <DashboardSlider items={completedItems} type="completed_items" title="Completed Items" />
                  ) : (
                    <h2>Visit a Booth or Breakout Session to complete your first item</h2>
                  )}
                  {uncompletedItems.train ? (
                    <DashboardSlider items={uncompletedItems} type="uncompleted_items" title="Uncompleted Items" />
                  ) : (
                    <h2>
                      <FontAwesomeIcon icon={['fas', 'award']} />
                      {" Congratulations! You've completed everything!"}
                    </h2>
                  )}
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
